export default __webpack_public_path__ + "static/media/02-Saeed-Al-Darmaki.0424cc1f.png";